import React from "react";
import {setLanguage} from "../store/details/projectDetailsSlice";
import {useDispatch, useSelector} from "react-redux";

const LanguageSelector = (props) => {
    const dispatch = useDispatch();
    const language = useSelector(state => state.projectDetailsReducer.language)

    const styles = {
        agencyDetailsLabel: {
            display: 'inline-block'
        },
        agencyDetails: {
            padding: '0 0 8px'
        },
        fieldWrapper: {
            marginLeft: '15px'
        }

    }
    const getLanguageSelect = () => {
        if(!props.languages) {
            return <></>
        }
        if(props.readOnly || !props.newQuote) {
            return language
        }
        const options = props.languages.map(lang =>
            <option value={lang}>{lang}</option>
        )
        return (
            <select onChange={(e) => handleLanguageChange(e.target.value)} defaultValue={language}>
                {options}
            </select>
        )
    }

    const handleLanguageChange = (val) => {
        dispatch(setLanguage(val));
    }

    return (
        <div className='small-12 columns' style={styles.agencyDetails}>
            <label style={styles.agencyDetailsLabel}>Language:</label>
            <span>{getLanguageSelect()}</span>
        </div>
    )
}

export default LanguageSelector